export default __webpack_public_path__ + "static/media/R870_3.8723a27e.png";